import styled from "styled-components";

const ModalContainer = styled.div<any>`
    height: 73vh;
`;

export default ModalContainer;